import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { FAST_FEATURES } from 'utils/constants'
import strings from 'utils/strings'
import { setChipFilters, submitSearch, resetChipFilters } from 'actions/search'
import { ChipTagMenu } from 'components/patterns'
import {
  StyledFilterItemContainer,
  ModuleLabel,
  StyledButton,
} from 'components/AdvanceFeaturesChipFilters/AdvancedFeaturesChipFilters.style'

const StretchedChipTagMenu = styled(ChipTagMenu)`
  flex-grow: 1 !important;
`

const EcuFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 410px;
`

const EcuChipRow = styled(StyledFilterItemContainer)`
  align-self: stretch;
`

const EcuButtonRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 15px;
  margin-bottom: 20px;
  margin-left: auto;
`

const ecuOptions = [
  { key: 'XMC 3', value: 'XMC 3', title: 'XMC 3' },
  { key: 'XMC 4', value: 'XMC 4', title: 'XMC 4' },
]

const defaultEcuTypes = ecuOptions.map((opt) => opt.value)

const FastFeaturesEcuChipFilters = ({
  searchString,
  isSearching,
  isHorizontalLayout,
  addToSearchRequestBody,
}) => {
  const dispatch = useDispatch()
  const [ecuTypes, setEcuTypes] = useState(defaultEcuTypes)
  const [appliedEcuTypes, setAppliedEcuTypes] = useState(defaultEcuTypes)

  useEffect(() => {
    if (isSearching && !filtersEqualApplied()) {
      setAppliedEcuTypes(ecuTypes)
    }
    // eslint-disable-next-line
  }, [isSearching, ecuTypes])

  const filtersEqualApplied = () =>
    ecuTypes.length === appliedEcuTypes.length &&
    appliedEcuTypes.every((ecu) => ecuTypes.includes(ecu))

  const handleSelectEcuType = (ecuValue) => {
    setEcuTypes(ecuValue)
    dispatch(setChipFilters({ queries: { ecuTypes: ecuValue } }, FAST_FEATURES))
  }

  const resetFilters = () => {
    setEcuTypes(defaultEcuTypes)
    dispatch(
      resetChipFilters(
        { queries: { ecuTypes: defaultEcuTypes } },
        FAST_FEATURES
      )
    )
  }

  const applyFilters = () => {
    setAppliedEcuTypes(ecuTypes)
    dispatch(submitSearch(FAST_FEATURES, true, addToSearchRequestBody))
  }

  return (
    <EcuFilterWrapper>
      <EcuChipRow
        className="filter-item-container"
        isHorizontalLayout={isHorizontalLayout}
      >
        <ModuleLabel isHorizontalLayout={isHorizontalLayout}>
          {strings.ecu}:
        </ModuleLabel>
        <StretchedChipTagMenu
          value={ecuTypes}
          options={ecuOptions}
          onChange={handleSelectEcuType}
        />
      </EcuChipRow>
      <EcuButtonRow>
        <StyledButton
          size="small"
          onClick={resetFilters}
          text={strings.reset}
          disabled={ecuTypes.length === defaultEcuTypes.length}
        />
        <StyledButton
          type="primary"
          size="small"
          onClick={applyFilters}
          text={strings.apply_filters}
          disabled={
            filtersEqualApplied() ||
            !ecuTypes.length ||
            (isHorizontalLayout && !searchString)
          }
        />
      </EcuButtonRow>
    </EcuFilterWrapper>
  )
}

FastFeaturesEcuChipFilters.propTypes = {
  searchString: PropTypes.string,
  isSearching: PropTypes.bool,
  isHorizontalLayout: PropTypes.bool,
  addToSearchRequestBody: PropTypes.object,
}

export default FastFeaturesEcuChipFilters
